import { FocusTrap } from "@aleksundshantu/aunds-utils-react/accessibility";
import { useModal } from "../ModalRoot/ModalRoot";
import styles from "./ModalContent.module.scss";

interface ModalContentProps {
  children: React.ReactNode;
}

const ModalContent = ({ children }: ModalContentProps) => {
  const { open, setOpen, absolutePosition } = useModal();

  return (
    open && (
      // eslint-disable-next-line jsx-a11y/no-autofocus -- ARIA APG: focus must move into dialog on open
      <FocusTrap autoFocus>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
        <div
          role="dialog"
          className={styles["modal-content"]}
          data-absolute-position={absolutePosition}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              setOpen(false);
            }
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setOpen(false);
            }
          }}
        >
          {children}
        </div>
      </FocusTrap>
    )
  );
};

export default ModalContent;
